import React from 'react';
import merge from 'lodash/merge';
import classnames from 'classnames';
export const Spinner = ({ additionalStyle }) => {
  return <span className={ classnames('spinner', additionalStyle) } />;
};

export const PageSpinner = ({ additionalStyle, className }) => {
  return (
    <div className={ classnames('spinner-container page-spinner', className) }>
      <span className={ classnames('spinner', additionalStyle) } />
    </div>
  )
};

export const SmallSpinner = ({ show, color, additionalStyle }) => {
  const spinnerColor = color ? color : 'initial';
  const spinnerStyle = merge({
    opacity: show ? 1 : 0,
    borderLeftColor: spinnerColor,
    borderTopColor: spinnerColor,
    borderBottomColor: spinnerColor }, additionalStyle);

  return (<span data-testid="spinner-small" style={spinnerStyle} className="spinner-small"></span>);
};

export const NextSpinner = ({}) => {
  return (
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  )
}
